import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Nav from '../components/Nav';
import TotalContainer from '../components/TotalContainer';
import Selections from '../components/amount/Selections';
import Loading from '../components/Loading';
import stepAnalytics from '../utils/stepAnalytics';
import Help from '../components/help/Help';

class AmountSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalContainerSticky: false,
      totalContainerLink: '/print/',
      totalContainerLinkText: this.props.generalTranslations.Print_Options
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    stepAnalytics('/amount', 'quantity', 'step 2');
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
    this.props.updateAlert('amount');
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.props.sizeSelection.length > 0)
      this.props.postSizes(this.props.sizeSelection);
  }

  toggleHelpAlert = () => {
    this.props.toggleHelp();
  };

  handleScroll() {
    if (window.pageYOffset > 175) {
      this.setState({ totalContainerSticky: true });
    } else {
      this.setState({ totalContainerSticky: false });
    }
  }

  render() {
    return (
      <div>
        <Nav />
        {this.props.helpShown && (
          <Help
            toggleAlert={this.toggleHelpAlert}
            path={this.props.match.path}
          />
        )}
        {this.props.sizes && this.props.sizes.length > 0 ? (
          <div className="teamsport_content">
            <div className="main_container">
              <div className="amount_selection">
                <Selections
                  productID={this.props.id}
                  choiceID={this.props.choices_id}
                  amountSelection={this.props.sizes}
                  helpElement="Amount"
                  toggleHelpAlert={this.toggleHelpAlert}
                />
              </div>
            </div>
            <TotalContainer
              totalContainerSticky={this.state.totalContainerSticky}
              totalContainerLink={this.state.totalContainerLink}
              totalContainerLinkText={this.state.totalContainerLinkText}
            />
          </div>
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}

const mapDispatch = dispatch => ({
  postSizes: sizes =>
    dispatch({
      type: 'POST_SIZES',
      sizes
    }),
  updateAlert: alertElement =>
    dispatch({
      type: 'UPDATE',
      alertElement
    }),
  toggleHelp: () =>
    dispatch({
      type: 'TOGGLE_HELP'
    })
});

const mapState = state => ({
  sizes: state.sizes,
  sizeSelection: state.sizeSelection,
  total: state.total,
  settings: state.settings,
  generalTranslations: state.generalTranslations,
  helpShown: state.helpShown
});

export default withRouter(connect(mapState, mapDispatch)(AmountSelection));
